export const AuthStatus = {
  Authenticated: "Authenticated",
  Unauthenticated: "Unauthenticated",
  Checking: "Checking",
};
